export default __webpack_public_path__ + "e75f22c37ab8c9cde34c6cf753126a89.svg";